import React from 'react'
import Container from 'react-bootstrap/Container'
import Buuton from './Buuton'

import {Link} from "react-router-dom";


export const NoMatch = () =>(


    <div>
        <Container>
            <h1>NoMatch</h1>
            <p>some text</p>
            <Link to="/"> <Buuton text="Home" /> </Link>
            
        </Container>
    </div>
)
